import { render } from "./WhatsNewInfo.vue?vue&type=template&id=95322702"
import script from "./WhatsNewInfo.vue?vue&type=script&lang=js"
export * from "./WhatsNewInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__